import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=07aff58e"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports